import { CANVAS_WIDTH, CANVAS_HEIGHT, clampSize, getToolConstraints } from "./canvasConstraints";

const removeCoordinate = (coordList, id) => {
  return coordList.filter((coord) => coord.eleId !== id);
};

const updateCoordinateMappingField = (coordList, id, e) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        mappingField: e,
        value: "",
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateIsRequired = (coordList, id, value) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        isRequired: value,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateUpdateFromSalesforceSettings = (coordList, id, value) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        updateFromSalesforce: value,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateEditable = (coordList, id, value) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        editable: value,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateWriteBackSettings = (coordList, id, value) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        writeBack: value,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateValue = (coordList, id, value) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        value: value,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateOptions = (coordList, id, options) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        options: options,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateName = (coordList, id, name) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        name: name,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateSignatory = (
  coordList,
  id,
  signatoryId,
  signatoryIndex,
  bgColor
) => {
  return coordList.map((item) => {
    if (item.eleId === id) {
      return {
        ...item,
        signatory_id: signatoryId,
        user_index_id: signatoryIndex,
        bgColor: bgColor,
      };
    } else {
      return item;
    }
  });
};

const updateCoordinateSize = (coordList, id, width, height, x, y, toolType, canvasDimensions = {}) => {
  const cw = canvasDimensions.width || CANVAS_WIDTH;
  const ch = canvasDimensions.height || CANVAS_HEIGHT;
  return coordList.map((item, index) => {
    if (item.eleId === id) {
      // Safety-net: clamp to min/max if toolType is provided
      let clampedWidth = width;
      let clampedHeight = height;
      if (toolType) {
        const constraints = getToolConstraints(toolType);
        const sized = clampSize(width, height, constraints);
        clampedWidth = sized.width;
        clampedHeight = sized.height;
      }
      let updatedItem = {
        ...item,
        width: clampedWidth,
        height: clampedHeight,
      };
      if (x !== undefined) {
        updatedItem.x = x < 0 ? 0 : x > cw - clampedWidth ? cw - clampedWidth : x;
      }
      if (y !== undefined) {
        updatedItem.y = y < 0 ? 0 : y > ch - clampedHeight ? ch - clampedHeight : y;
      }
      return updatedItem;
    } else {
      return item;
    }
  });
};

const updateCoordinatePosition = (coordList, id, x, y, canvasDimensions = {}) => {
  const cw = canvasDimensions.width || CANVAS_WIDTH;
  const ch = canvasDimensions.height || CANVAS_HEIGHT;
  return coordList.map((item, index) => {
    if (item.eleId === id) {
      return {
        ...item,
        x: x < 0 ? 0 : x > cw - item.width ? cw - item.width : x,
        y: y < 0 ? 0 : y > ch - item.height ? ch - item.height : y,
      };
    } else {
      return item;
    }
  });
};

export {
  updateCoordinateMappingField,
  removeCoordinate,
  updateCoordinateValue,
  updateCoordinateOptions,
  updateCoordinateIsRequired,
  updateCoordinateUpdateFromSalesforceSettings,
  updateCoordinateWriteBackSettings,
  updateCoordinateName,
  updateCoordinateEditable,
  updateCoordinateSignatory,
  updateCoordinateSize,
  updateCoordinatePosition,
};
